class UpsellOffersInfoUIModel {
  constructor({
    ancillary = undefined,
    currency = undefined,
    legCode = undefined,
    quantity = undefined,
    seatsRemaining = undefined,
    segmentCode = undefined,
    upgradeAvailable = undefined,
    upgradeBenefitCobrand = undefined,
  } = {}) {
    this.ancillary = ancillary;
    this.currency = currency;
    this.legCode = legCode;
    this.quantity = quantity;
    this.seatsRemaining = seatsRemaining;
    this.segmentCode = segmentCode;
    this.upgradeAvailable = upgradeAvailable;
    this.upgradeBenefitCobrand = upgradeBenefitCobrand;
  }
}

export default UpsellOffersInfoUIModel;
